import {getCookie, setCookie} from "@helpers/cookie/cookie";
import {THEME_SEIZE_COOKIE_KEY} from "@view/theme/constants/cookie";
import {UiThemeSize} from "@view/theme/types";

export const saveThemeSize = (themeSize:UiThemeSize)=>{
    setCookie(THEME_SEIZE_COOKIE_KEY,themeSize)
}

export const getInitialThemeSize = ():UiThemeSize=>{
    const cookieSize = getCookie(THEME_SEIZE_COOKIE_KEY)
    if(cookieSize === 'small' || cookieSize === 'large'){
        return  cookieSize
    }

    return  'large'
}